import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/material/locale";
import "../Theme/Theme.types";
export const darkTheme = createTheme({
    direction: "rtl",
    palette: {
        mode: "dark",
        primary: {
            main: "#54B8B0", // از 80 لایت
            light: "#B0D0CC", // از 95 لایت
            dark: "#00484B", // از 30 لایت
            contrastText: "#002826",
        },
        error: {
            main: "#ECB0B0", // از 90 لایت
            light: "#F9E6E6", // از 95 لایت
            dark: "#C10101", // از 50 لایت
            contrastText: "#6A0101",
        },
        success: {
            main: "#B5E28A", // G-90
            light: "#EFF9E6", // G-95
            dark: "#5EC101", // G-50
            contrastText: "#275100",
        },
        warning: {
            main: "#E2CC8A", // Y-90
            light: "#F9F4E6", // Y-95
            dark: "#C19101", // Y-50
            contrastText: "#513000",
        },
        info: {
            main: "#8AD2E2", // B-90
            light: "#E8F5F9", // B-95
            dark: "#019EC1", // B-50
            contrastText: "#004251",
        },
        background: {
            default: "#121212", // از neutral-10
            paper: "#1E1E1E",
        },
        text: {
            primary: "#EEEEEE", // از neutral-95
            secondary: "#A3A3A3", // از neutral-50
        },
    },
    customColors: {
        primary: {
            98: "#002826", // معکوس
            95: "#003832",
            90: "#00484B",
            80: "#005D52",
            60: "#00865A",
            50: "#33B57B",
            40: "#54B8B0",
            30: "#BABBB3",
            20: "#B0D0CC",
            10: "#E6F0EF",
            primaryContainer: "#00484B", // تیره برای دارک
            onPrimaryContainer: "#B0D0CC",
            onPrimary: "#002826",
        },
        neutral: {
            98: "#121212", // معکوس
            95: "#454545",
            90: "#616161",
            80: "#7F7F7F",
            70: "#A3A3A3",
            50: "#D1D1D1",
            40: "#EBEBEB",
            30: "#EEEEEE",
            20: "#F4F4F4",
            10: "#FFFFFF",
            surfaceContainerLowest: "#0A0A0A",
            surfaceContainerLow: "#1A1A1A",
            surfaceContainer: "#1E1E1E",
            onSurface: "#EEEEEE",
            onSurfaceVariant: "#D1D1D1",
            outline: "#616161",
        },
        error: {
            98: "#6A0101", // معکوس
            95: "#C10101",
            90: "#ECB0B0",
            50: "#F9E6E6",
            20: "#FDF8F8",
            errorContainer: "#6A0101",
            onErrorContainer: "#F9E6E6",
            onError: "#FDF8F8",
        },
        success: {
            98: "#275100", // معکوس
            95: "#5EC101",
            90: "#B5E28A",
            50: "#EFF9E6",
            20: "#F4F7F1",
            successContainer: "#275100",
            onSuccessContainer: "#EFF9E6",
            onSuccess: "#F4F7F1",
        },
        warning: {
            98: "#513000", // معکوس
            95: "#C19101",
            90: "#E2CC8A",
            50: "#F9F4E6",
            20: "#F9F6F4",
            warningContainer: "#513000",
            onWarningContainer: "#F9F4E6",
            onWarning: "#F9F6F4",
        },
        info: {
            98: "#004251", // معکوس
            95: "#019EC1",
            90: "#8AD2E2",
            50: "#E8F5F9",
            20: "#F2F7F8",
            infoContainer: "#004251",
            onInfoContainer: "#E8F5F9",
            onInfo: "#F2F7F8",
        },
    },
    typography: {
        fontFamily: ["IRANSansX", "IRANSansXBold"].join(","),
        displayLarge: {
            fontSize: "48px",
            lineHeight: "72px",
            fontWeight: 700,
            color: "#EEEEEE",
        },
        displaySmall: {
            fontSize: "32px",
            lineHeight: "56px",
            fontWeight: 700,
            color: "#EEEEEE",
        },
        headlineLarge: {
            fontSize: "24px",
            lineHeight: "44px",
            fontWeight: 700,
            color: "#EEEEEE",
        },
        titleLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 700,
            color: "#EEEEEE",
        },
        titleMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#EEEEEE",
        },
        labelLarge: {
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
        labelMedium: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
        labelSmall: {
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
        bodyLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
        bodyMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
        bodySmall: {
            fontSize: "12px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#EEEEEE",
        },
    },
}, faIR);
